import { withInstall } from '@lit-element/utils'

import Link from './src/link.vue'
import type { SFCWithInstall } from '@lit-element/utils'

export const LtLink: SFCWithInstall<typeof Link> = withInstall(Link)
export default LtLink

export * from './src/link'
